<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="角色管理名称">
          <el-input placeholder="请输入角色管理名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick"
      
      v-auth="'/plus/urole/index/add'">添加角色管理</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="code" label="编码"></el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0">未开启</div>
                <div v-if="scope.row.status == 1">开启</div>
              </template>
            </el-table-column>
            <el-table-column prop="main_path" label="主路径"></el-table-column>
            <el-table-column prop="order_detail_path" label="订单详情路径"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="authClick(scope.row)" type="text" size="small" 

               
                v-auth="'/plus/urole/index/auth'">权限</el-button>
                <el-button @click="editClick(scope.row)" 
                v-auth="'/plus/urole/index/edit'"
                type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" 
                v-auth="'/plus/urole/index/del'"
                type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :user_role_id="user_role_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
    <Auth v-if="open_auth" :open_add="open_auth" :user_role_id="user_role_id"  @closeDialog="closeDialogFunc($event, 'auth')"></Auth>

  </div>
</template>

<script>
  import UroleApi from '@/api/urole.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  import Auth from './part/auth.vue';
  export default {
    components: {
      Add,
      Edit,
      Auth,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        user_role_id:"",
        dialogVisible:false,
        userModel:{},
        open_auth:false,

        /*权限选中*/
        select_menu: [],
        /*权限树菜单重新自定义字段*/
        defaultProps: {
          children: 'children',
          label: 'name'
        },
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      authClick(row){
        this.user_role_id = row.user_role_id;
        this.open_auth = true;
      },
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//角色管理标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        UroleApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.user_role_id = row.user_role_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            UroleApi.del(
              {
                user_role_id: row.user_role_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
         /*关闭弹窗*/
    closeDialogFunc(e, f) {

      if (f == 'auth') {
        this.open_auth = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
  
    },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/urole/index/index.vue